import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Header from './Header';
import Footer from './Footer';
import CreateAccount from './CreateAccount';
import Pricing from './Pricing';

const useStyles = theme => ({
    root: {
        top: '-20px',
        backgroundColor: '#F8F8F8',
        width: '100%'
    },
    footer: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundBlendMode: 'overlay',
        width: '100%',
        backgroundColor: '#E9F2FF'
    }
});

class LandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marinaPaymentsId: '',
            returnURL: ''
        };
    }

    async componentDidMount() {
        console.log('LandingPage.componentDidMount()');
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                {/* <Header /> */}
                <Pricing/>
                {/* <Footer /> */}
            </div>
        );
    };
};

export default withStyles(useStyles)(LandingPage);